import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { IntlProvider} from 'react-intl';
import { LoadingOutlined } from '@ant-design/icons';
import { ConfigProvider, Spin } from 'antd';

// import '@formatjs/intl-relativetimeformat/polyfill'
// import '@formatjs/intl-relativetimeformat/locale-data/en.js' 
// import '@formatjs/intl-relativetimeformat/locale-data/el' 
// import '@formatjs/intl-relativetimeformat/locale-data/it' 

// import '@formatjs/intl-pluralrules/polyfill'
// import '@formatjs/intl-pluralrules/locale-data/en.js'
// import '@formatjs/intl-pluralrules/locale-data/el'
// import '@formatjs/intl-pluralrules/locale-data/it'


import GlobalConfigProvider from './Config/GlobalConfigContext';
import Auth from './Auth';
//import antdEn from 'antd/lib/locale-provider/en_US';
import antdEl from 'antd/lib/locale-provider/el_GR';
import antdIt from 'antd/lib/locale-provider/it_IT';
// import appLocaleDataEn from 'react-intl/locale-data/en';
// import appLocaleDataEl from 'react-intl/locale-data/el';
// import appLocaleDataIt from 'react-intl/locale-data/it';
//import enMessages from '../locales/en.json';
//import elMessages from '../locales/el.json';
//import itMessages from '../locales/it.json';
import * as notifications from '../actions/notifications';
import api from '../middleware/api';



// if (!Intl.PluralRules) {
//     require('@formatjs/intl-pluralrules/polyfill');
//     require('@formatjs/intl-pluralrules/locale-data/en'); // Add locale data for en
//     require('@formatjs/intl-pluralrules/locale-data/el'); // Add locale data for el
//     require('@formatjs/intl-pluralrules/locale-data/it'); // Add locale data for it
// }

// if (!Intl.RelativeTimeFormat) {
//     //if (typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
//         require('@formatjs/intl-relativetimeformat/polyfill');
//         require('@formatjs/intl-relativetimeformat/locale-data/en'); // Add locale data for en
//         require('@formatjs/intl-relativetimeformat/locale-data/el'); // Add locale data for el
//         require('@formatjs/intl-relativetimeformat/locale-data/it'); // Add locale data for it
//     //}
// }

//const { intl } = IntlProvider.getChildContext();

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
/*
const language = (navigator.languages && navigator.languages[0]) ||
                     navigator.language ||
                     navigator.userLanguage;
//console.log('language', language);

// Split locales with a region code
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
//console.log('languageWithoutRegionCode', languageWithoutRegionCode);
*/


class HotSwappingIntlProvider extends React.PureComponent {
	/*static childContextTypes = {
		intl: intlShape.isRequired
	};
	getChildContext() {
		return {
			intl: intl  
		};
  	}*/
    constructor(props) {
        super(props);
        //const {initialLocale: locale, initialMessages: messages} = props;
        this.state = {
            messages: {},
            antd: null,
            fetching: false
		};
        //this.changeListener = this._handleChange.bind(this);
    }
    componentDidMount = () => {
        //console.log(`HotSwappingIntlProvider componentDidMount:`)
        // const { language } = this.props;
        //console.log('locale', locale, 'language', language, 'timezone', timezone);
        // this.getLocalizedMessages(language);

    }
    componentDidUpdate = (prevProps) => {
        //console.log(`componentDidUpdate:`, prevProps, this.props)
        if(prevProps.language !== this.props.language){
            //console.log(`Modified language:`, prevProps.language, this.props.language)
            // this.getLocalizedMessages(this.props.language);
        }
    }
    getLocalizedMessages(locale) {
        //console.log(`this.props.isAuthenticated:`, this.props.isAuthenticated)
        if(!this.props.isAuthenticated){
            this.setState({ fetching: false });
            return false
        }

        if(locale.includes('en')){
            this.setState({ messages: {}, fetching: false, antd: {} });
            return false;
        }

        this.setState({ fetching: true });
        api.get(`/translations/locale/${locale}.json`)
			.then(response => {
                if(response.data){
                    //console.log(`response.data:`, response.data)
                    let antd = null;
                    if(locale === 'el'){
                        antd = antdEl;
                    }else if (locale === 'it'){
                        antd = antdIt;
                    }
                    this.setState({ messages: response.data, fetching: false, antd });
                }else{
                    this.props.notifications.notify({
                        title: 'Invalid Language!',
                        message:  response.data.error,
                        type: 'notification',
                        kind: 'error'
                    });
                    this.setState({ fetching: false });
                }
		    	//this.setState({ fetchingAFM: false });
		}).catch(error => {
			this.props.notifications.notify({
                title: 'Invalid Language!',
                message:  error.message,
                type: 'notification',
                kind: 'error'
            });	
            this.setState({ fetching: false });
		});
    }

    render() {
	    const { locale, timezone } = this.props;
        const { messages, antd, fetching } = this.state;
        const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
        //console.log('locale', locale, 'language', language, 'timezone', timezone);
        if(fetching){
            return <Spin indicator={antIcon} className="content-loading" />
        }
        // let appLocale;
        // switch(language){
        //     case 'el':
        //     appLocale = {
        //         messages: {
        //             ...elMessages
        //         },
        //         antd: antdEl,
        //         locale: locale,
        //         parentLocale: 'en',
        //         //data: appLocaleDataEl,
        //     }
        //     break;
        //     case 'it':
        //     appLocale = {
        //         messages: {
        //             ...itMessages
        //         },
        //         antd: antdIt,
        //         locale: locale,
        //         parentLocale: 'en',
        //         //data: appLocaleDataIt,
        //     }
        //     break;
        //     default:
        //     appLocale = {
        //         messages: {
        //             //...enMessages
        //         },
        //         antd: antdEn,
        //         locale: locale,
        //         parentLocale: 'en',
        //         //data: appLocaleDataEn,
        //     }
        // }
	    // const appLocale = (language === "el")?{
		// 	messages: {
		// 		...elMessages
		// 	},
		// 	antd: antdEl,
		// 	locale: locale,
		// 	parentLocale: 'en',
		// 	data: appLocaleDataEl,
		// }:{
		// 	messages: {
		// 		//...enMessages
		// 	},
		// 	antd: antdEn,
		// 	locale: locale,
		// 	parentLocale: 'en',
		// 	data: appLocaleDataEn,
		// };
        //Intl.DateTimeFormat().resolvedOptions().timeZone
        //console.log(`timezone:`, timezone);
		// const intlProviderProps = {
		// 	locale:locale,
		// 	defaultLocale:"en-US",
		// 	//messages:appLocale.messages,
		// 	key:locale,
		// 	timeZone:timezone
		// }
		//const intlProvider = new IntlProvider(intlProviderProps);
		//const { intl } = intlProvider.getChildContext();
        return (
	        <ConfigProvider locale={antd}>
					<IntlProvider
                        locale={locale == 'en-US' ? 'en-GB' : locale}
                        defaultLocale="en-GB"
                        messages={messages}
                        key={locale == 'en-US' ? 'en-GB' : locale}
			            timeZone={timezone}
						// {...intlProviderProps}
						//locale={locale}
						//defaultLocale="en-US"
						//defaultLocale="el-GR"
						//key={locale}
						//messages={appLocale.messages}
						//timeZone={timezone}
						/*formats={{ 
							time: {
								'hour-only': {
									hour: '2-digit',
									hour12: false,
								},
							},
							date: {
								'year-only': {
									year: 'numeric',
								},
								missing: undefined,
							},
						}}*/
					>
						<GlobalConfigProvider /*intl={intl}*/ notifications={this.props.notifications}>
							<Auth>
								{this.props.children}
							</Auth>
						</GlobalConfigProvider>
					</IntlProvider>
				
	        </ConfigProvider>
        );
    }
}

const mapStateToProps = state => ({
	locale: state.auth.locale,
	language: state.auth.language,
	timezone: state.auth.timezone,
	isAuthenticated: state.auth.isAuthenticated,
})
const mapDispatchToProps = dispatch => ({
	notifications: bindActionCreators(notifications, dispatch),
	dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(HotSwappingIntlProvider);